import React from 'react';

import { NextPage } from 'next';

import { ContactPage } from '../components';

const ContactNextPage: NextPage = () => {
  return <ContactPage />;
};

// eslint-disable-next-line import/no-default-export
export default ContactNextPage;
